<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify :active="key == 31 ? 4 : 1" all-active />
    <iRightFixedBox />
    <iPageTitle :text="pageTitle" />
    <div class="container">
      <van-row type="flex">
        <van-col span="4" class="left-nav">
          <iMineNav
            :actived-parent-key="pKey"
            :actived-key="key"
            :help-center="helpCenter"
            @handleNav="handleNav"
          />
        </van-col>
        <van-col
          span="19"
          :class="{ pl20: key != 11 }"
          style="position: relative;"
        >
          <slot name="rightContent" />
        </van-col>
      </van-row>
    </div>
    <iFooter />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iMineNav from '@/components/iMineNav'
import iClassify from '@/components/Classify'
import iPageTitle from '@/components/PageTitle'
import iFooter from '@/components/Footer'
import iRightFixedBox from '@/components/RightFixedBox'

export default {
  name: 'IMineTemplate',
  components: {
    iHeader,
    iNav,
    iFooter,
    iRightFixedBox,
    iClassify,
    iPageTitle,
    iMineNav
  },
  props: {
    activedParentKey: { type: Number, default: 1 },
    activedKey: { type: Number, default: 11 },
    helpCenter: { type: Boolean, default: false },
    pageTitle: { type: Array, default: () => ['我的账户', '个人中心'] }
  },
  data() {
    return {
      pKey: 1,
      key: 11
    }
  },
  watch: {
    activedParentKey: {
      handler(val) {
        if (val != this.pKey) {
          this.pKey = val
        }
      },
      immediate: true
    },
    activedKey: {
      handler(val) {
        if (val != this.key) {
          this.key = val
        }
      },
      immediate: true
    }
  },
  methods: {
    handleNav(item, v) {
      this.$emit('handleNav', item, v)
    }
  }
}
</script>

<style scoped lang="less">
.container {
  margin: 16px auto 80px;
  width: 1200px;
}

.left-nav {
  border: 1px solid rgba(232, 232, 232, 1);
  width: 240px;
  background: rgba(255, 255, 255, 1);
}
</style>
